<template>
  <div class="contacts">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper" style="min-height: 100vh;">
        <!-- Contact Main Row -->
        <div class="chat-main-row">
          <!-- Contact Wrapper -->
          <div class="chat-main-wrapper">
            <div class="col-lg-12 message-view">
              <div class="chat-window">
                <div class="fixed-header">
                  <div class="row">
                    <div class="col-6">
                      <h4 class="page-title mb-0">Kontak</h4>
                    </div>
                    <div class="col-6">
                      <div class="navbar justify-content-end">
                        <div class="search-box m-t-0">
                          <div class="input-group input-group-sm">
                            <input
                              v-model="contactListParam.name"
                              type="text"
                              class="form-control"
                              placeholder="Search"
                              @change="filterContactListByName"
                            />
                            <span class="input-group-append">
                              <button @click="filterContactListByName" class="btn" type="button">
                                <i class="fa fa-search"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-contents">
                  <div class="chat-content-wrap">
                    <div class="chat-wrap-inner">
                      <div class="contact-box">
                        <div class="row">
                          <div class="contact-cat col-sm-4 col-lg-3">
                            <div class="input-group text-right" v-if="contactListArr.length>0">
                              <button
                                class="btn btn-outline-secondary dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >Options</button>

                              <div class="dropdown-menu">
                                <router-link
                                  :to="'/contacts/sync-contacts'"
                                  class="dropdown-item btn-block"
                                >
                                  <i class="fa fa-cloud"></i> Synchronize Whatsapp contacts
                                </router-link>
                                <router-link
                                  :to="'/contacts/import-contacts'"
                                  class="dropdown-item btn-block"
                                >
                                  <i class="fa fa-upload"></i> Import contact
                                </router-link>
                                <a
                                  href="#"
                                  class="dropdown-item btn-block"
                                  data-toggle="modal"
                                  data-target="#add_group"
                                >
                                  <i class="fa fa-users"></i> Add a new group
                                </a>
                                <a
                                  href="#"
                                  class="dropdown-item btn-block"
                                  data-toggle="modal"
                                  data-target="#add_contact"
                                >
                                  <i class="fa fa-user"></i> Add a new contact
                                </a>

                                <hr />
                                <a
                                  href="#"
                                  class="dropdown-item btn-block"
                                  @click.prevent="removeAllGroup"
                                >
                                  <i class="fa fa-trash"></i> Remove All group
                                </a>
                                <a
                                  href="#"
                                  class="dropdown-item btn-block"
                                  @click.prevent="unassignFromAllGroup"
                                >
                                  <i class="fa fa-close"></i> Unassign All contact
                                </a>
                                <a
                                  href="#"
                                  class="dropdown-item btn-block"
                                  @click.prevent="removeAllContact"
                                >
                                  <i class="fa fa-trash"></i> Remove All contact
                                </a>
                              </div>
                            </div>

                            <div class="roles-menu">
                              <ul>
                                <li :class="((currentGroupId=='')?'active':'')">
                                  <a v-on:click="filterContactListGroup('')">All ~ {{allContacts}}</a>
                                </li>
                                <li v-if="loadingGroup">
                                  <Skeleton :height="'30px'" :count="1" />
                                </li>
                                <li v-if="loadingGroup">
                                  <Skeleton :height="'30px'" :count="1" />
                                </li>
                                <template v-for="rowG in groupListArr">
                                  <li
                                    :key="rowG.id"
                                    :class="((currentGroupId==rowG.id)?'active':'')"
                                  >
                                    <a v-on:click="filterContactListGroup(rowG.id)">{{rowG.name}}</a>
                                  </li>
                                </template>
                              </ul>
                            </div>
                          </div>
                          <div class="contacts-list col-sm-8 col-lg-9">
                            <div class="row" v-if="contactListArr.length">
                              <div class="col top-action-left" style="margin:5px;">
                                <div class="float-left">
                                  <div class="btn-group">
                                    <button
                                      href="javascript:void(0)"
                                      @click="exportData"
                                      class="btn btn-outline-secondary"
                                    >
                                      <i class="fa fa-file-excel-o"></i> Export
                                    </button>
                                  </div>
                                  <div class="btn-group dropdown-action">
                                    <button
                                      type="button"
                                      class="btn btn-white dropdown-toggle"
                                      data-toggle="dropdown"
                                    >
                                      <i class="fa fa-users"></i> Assign / Unassign
                                      <i class="fa fa-angle-down"></i>
                                    </button>

                                    <div class="dropdown-menu">
                                      <a
                                        :disabled="(selectedCheckbox==0)?true:false"
                                        class="dropdown-item"
                                        href="javascript:void(0)"
                                        data-toggle="modal"
                                        data-target="#edit_group"
                                        @click="actShowHideUpdateGroup"
                                      >Assign to Group</a>
                                      <a
                                        @click.prevent="unassignContactSelected"
                                        v-if="contactListParam.group_id.length>0"
                                        :disabled="(selectedCheckbox==0 || contactListParam.group_id.length==0)?true:false"
                                        class="dropdown-item"
                                        href="javascript:void(0)"
                                      >Unassign</a>
                                      <div
                                        class="dropdown-divider"
                                        v-if="contactListParam.group_id.length>0"
                                      ></div>
                                      <a
                                        class="dropdown-item"
                                        @click.prevent="unassignFromOneGroup"
                                        v-if="contactListParam.group_id.length>0"
                                      >Unassign All</a>
                                    </div>
                                  </div>
                                  <div class="btn-group">
                                    <div class="btn-group dropdown-action">
                                      <button
                                        type="button"
                                        class="btn btn-danger dropdown-toggle"
                                        data-toggle="dropdown"
                                      >
                                        <i class="fa fa-trash"></i> Remove
                                        <i class="fa fa-angle-down"></i>
                                      </button>
                                      <div class="dropdown-menu">
                                        <a
                                          @click.prevent="removeOneGroup"
                                          v-if="contactListParam.group_id.length>0"
                                          class="dropdown-item"
                                          href="javascript:void(0)"
                                        >Remove Group</a>
                                        <a
                                          class="dropdown-item"
                                          @click.prevent="deleteContactSelected"
                                          :disabled="(selectedCheckbox==0)?true:false"
                                          href="javascript:void(0)"
                                        >Remove Contact</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <ul class="contact-list" id="ul-contact-list">
                              <li v-if="!loadingMessage && contactListArr.length<1">
                                <div class="col-md-12">
                                  <div class="row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                      <div
                                        class="contact-cont text-muted text-center"
                                      >Data is currently empty. Make your first contact.</div>
                                    </div>
                                    <div class="col-md-2"></div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                      <div class="input-group text-center">
                                        <button
                                          class="btn btn-outline-secondary dropdown-toggle"
                                          type="button"
                                          data-toggle="dropdown"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                        >Options</button>

                                        <div class="dropdown-menu">
                                          <router-link
                                            :to="'/contacts/sync-contacts'"
                                            class="dropdown-item btn-block"
                                          >
                                            <i class="fa fa-cloud"></i> Synchronize Whatsapp contacts
                                          </router-link>
                                          <router-link
                                            :to="'/contacts/import-contacts'"
                                            class="dropdown-item btn-block"
                                          >
                                            <i class="fa fa-upload"></i> Import contact
                                          </router-link>
                                          <a
                                            href="#"
                                            class="dropdown-item btn-block"
                                            data-toggle="modal"
                                            data-target="#add_contact"
                                          >
                                            <i class="fa fa-user"></i> Add a new contact
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4"></div>
                                  </div>
                                </div>
                              </li>
                              <li v-if="loadingMessage">
                                <div class="contact-cont">
                                  <div class="float-left user-img">
                                    <img
                                      class="rounded-circle avatar"
                                      alt
                                      src="../../assets/profiles/avatar-02.jpg"
                                    />
                                  </div>
                                  <div class="contact-info">
                                    <span class="contact-name text-ellipsis">
                                      <Skeleton :count="1" />
                                    </span>
                                    <span class="contact-date">
                                      <Skeleton :count="1" />
                                    </span>
                                  </div>
                                </div>
                              </li>
                              <li v-for="row in contactListArr" :key="row.id">
                                <div class="contact-cont">
                                  <div style="margin-right:10px;" class="float-left user-img">
                                    <input
                                      v-bind:id="row.id"
                                      v-bind:checked="parentChecked"
                                      @change="checkChild(row.id, $event)"
                                      type="checkbox"
                                      class="form-control"
                                    />
                                  </div>
                                  <div :for="row.id" class="float-left user-img">
                                    <span class="avatar">
                                      <img
                                        class="rounded-circle"
                                        alt
                                        src="../../assets/profiles/avatar-09.jpg"
                                      />
                                      <span class="status online"></span>
                                    </span>
                                  </div>
                                  <div class="contact-info">
                                    <span
                                      v-if="row.first_name==''"
                                      class="contact-name text-ellipsis"
                                    >No-Name</span>
                                    <span v-else class="contact-name text-ellipsis">
                                      {{row.first_name}}
                                      {{row.last_name}}
                                    </span>
                                    <span class="contact-date" v-if="row.phone_number!='0'">
                                      <i class="fa fa-phone-square"></i>
                                      {{row.phone_number}}
                                    </span>
                                    <span class="contact-date" v-if="row.email!='' && row.is_group==0">
                                      <i class="fa fa-envelope-o"></i>
                                      {{row.email}}
                                    </span>
                                     <span class="contact-date" v-if="row.phone_number_group!='' && row.is_group==1">
                                      <i class="fa fa-phone-square"></i>
                                      {{row.phone_number_group}} (<b>{{row.provider}} group</b>)
                                    </span>
                                  </div>
                                  <ul class="contact-action">
                                    <li class="dropdown dropdown-action">
                                      <a
                                        href
                                        class="dropdown-toggle action-icon"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="material-icons">more_vert</i>
                                      </a>
                                      <div class="dropdown-menu dropdown-menu-right">
                                        <a
                                          :disabled="(row.is_group==1)?true:false"
                                          class="dropdown-item"
                                          href="javascript:void(0)"
                                          data-toggle="modal"
                                          data-target="#edit_contact"
                                          @click="actShowHideUpdate(row.id)"
                                        >Edit</a>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </li>
                            </ul>
                            <infinite-loading-contact
                              spinner="spiral"
                              :identifier="infiniteId"
                              @infinite="infiniteHandlerContact"
                            >
                              <div slot="spinner">
                                <span v-if="loadingMessage">Loading...</span>
                              </div>
                              <!-- <div slot="no-more">No more messages</div> -->
                              <div slot="no-more">
                                <span
                                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered>=this.contactListParam.totalRecords)"
                                >No more messages</span>
                                <span
                                  v-if="(this.contactListParam.totalRecords==0)"
                                >No more messages</span>
                                <span
                                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered==0)"
                                >No more messages</span>
                              </div>
                              <div slot="no-results">
                                <span
                                  v-if="(this.contactListParam.totalRecords==0)"
                                >No results message</span>
                                <span v-else>No more messages</span>
                              </div>
                            </infinite-loading-contact>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Contact Wrapper -->
        </div>
        <!-- /Contact Main Row -->

        <!-- Add Contact Modal -->
        <create-contact :filterContactListGroup="filterContactListGroup" />
        <!-- /Add Contact Modal -->

        <!-- Edit Contact Modal -->
        <update-contact :filterContactListGroup="filterContactListGroup" :showUpdate="showUpdate" />
        <!-- /Edit Contact Modal -->

        <create-group />
        <update-group
          :filterContactListGroup="filterContactListGroup"
          :showUpdateGroup="showUpdateGroup"
          :selectedCheckbox="selectedCheckbox"
        />

        <!-- Delete Contact Modal -->
        <div class="modal custom-modal fade" id="delete_contact" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Contact</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a href="javascript:void(0);" class="btn btn-primary continue-btn">Delete</a>
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                      >Cancel</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Contact Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import InfiniteLoading from "vue-infinite-loading";
import { Skeleton } from "vue-loading-skeleton";
import CreateContact from "./createContact.vue";
import UpdateContact from "./updateContact.vue";
import UpdateGroup from "./updateGroup.vue";
import CreateGroup from "./createGroup.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    InfiniteLoadingContact: InfiniteLoading,
    Skeleton,
    CreateContact,
    UpdateContact,
    UpdateGroup,
    CreateGroup
  },
  data() {
    return {
      allContacts: 0,
      showUpdateGroup: "",
      selectedCheckbox: [],
      parentChecked: false,
      btnActionDisabled: true,
      infiniteId: +new Date(),
      showUpdate: "",
      loadingGroup: false,
      currentState: null,
      loadingMessage: true,
      initScrollTop: 0,
      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      contactListParam: {
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100,
        rendered: 0,
        totalRecords: 0
      }
    };
  },
  computed: {
    contactListArr() {
      return this.$store.state.contact.contactListArr;
    },
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },

  beforeDestroy() {
    this.$root.$off("getGroupList");
  },
  methods: {
    removeAllGroup() {
      this.$fire({
        title: "Are you sure you want to remove All Group? ",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          let formDeleteSelected = {
            group_id: ""
          };
          this.$store
            .dispatch("contact/removeGroup", formDeleteSelected)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(r => {
                this.getGroupList();
                this.contactListParam.group_id = [];
                this.filterContactListByName();
                this.currentGroupId = "";
              });
            });
        }
      });
      this.selectedCheckbox = [];
    },
    removeOneGroup() {
      if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to remove",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title: "Are you sure you want to remove this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              group_id: this.contactListParam.group_id[0]
            };
            this.$store
              .dispatch("contact/removeGroup", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.getGroupList();
                  this.contactListParam.group_id = [];
                  this.filterContactListByName();
                  this.currentGroupId = "";
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    exportData() {
      let newParam = this.contactListParam;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 0; //unlimited
      this.$store.dispatch("contact/exportData", newParam).then(response => {
        this.$fire({
          title: "Preparing",
          text: response["msg"],
          type: "warning",
          timer: 3000
        });
      });
    },
    unassignFromAllGroup() {
      this.$fire({
        title:
          "Are you sure you want to unassign all contacts from all group? ",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          let formDeleteSelected = {
            group_id: ""
          };
          this.$store
            .dispatch("contact/unassignGroup", formDeleteSelected)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(r => {
                this.contactListParam.group_id = [];
                this.filterContactListByName();
                this.getGroupList();
                this.selectedCheckbox = [];
              });
            });
        }
      });
    },
    unassignFromOneGroup() {
      if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to unassign all contacts from this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              group_id: this.contactListParam.group_id[0]
            };
            this.$store
              .dispatch("contact/unassignGroup", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListGroup(
                    this.contactListParam.group_id[0]
                  );
                  this.getGroupList();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    unassignContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Warning",
          text: "Please select one or more contacts to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to unassign some contacts from this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              id: this.selectedCheckbox,
              group_id: this.contactListParam.group_id[0]
            };
            this.$store
              .dispatch("contact/unassignContactSelected", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListGroup(
                    this.contactListParam.group_id[0]
                  );
                  this.getGroupList();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    deleteContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Warning",
          text: "Please select one or more contacts to delete",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to delete some contacts? This action cannot be rolled back.",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              id: this.selectedCheckbox
            };
            this.$store
              .dispatch("contact/deleteContactSelected", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListByName();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    removeAllContact() {
      this.$fire({
        title:
          "Are you sure you want to remove all contacts? This action cannot be rolled back.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          this.$store.dispatch("contact/removeAllContact").then(response => {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.filterContactListByName();
            });
          });
        }
      });
    },
    checkChild: function(idx, $event) {
      // console.log("idx", idx);
      // console.log("$event", $event.target.checked);
      if ($event.target.checked == true) {
        this.selectedCheckbox.push(idx);
        this.btnActionDisabled = false;

        // this.$store.dispatch("bonus/selectedWD", this.selectedWD);
      } else {
        if (this.selectedCheckbox.length > 0) {
          let index = this.selectedCheckbox.indexOf(idx);
          if (index > -1) {
            // only splice array when item is found
            this.selectedCheckbox.splice(index, 1); // 2nd parameter means remove one item only
          }
        } else {
          this.btnActionDisabled = true;
        }
      }
    },
    actShowHideUpdateGroup() {
      this.showUpdateGroup = "1";
    },
    actShowHideUpdate(value) {
      this.showUpdate = value;
    },
    async filterContactListByName() {
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 100;
      this.contactListParam.group_id = [];
      this.infiniteId += 1;
      this.selectedCheckbox = [];

      // this.infiniteHandlerContact();
    },
    async filterContactListGroup(groupId) {
      this.currentGroupId = groupId;
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 100;
      this.contactListParam.group_id = [];
      if (groupId !== "") {
        this.contactListParam.group_id.push(groupId);
      }
      this.infiniteId += 1;
      this.selectedCheckbox = [];

      // this.infiniteHandlerContact();
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    async changeContactListArr(data) {
      //   console.log("panrtnenemee", data);
      //   console.log("contactListArrxxx::", this.contactListArr);
      var newArr = await this.getUniqueListBy(data, "id");
      //   console.log("newArr", newArr);

      // console.log("builllll", buildArr);
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      await this.$store.dispatch("contact/setContactListArr", newArr);
    },
    async infiniteHandlerContact($state) {
      // console.log("staaate", $state);
      this.loadingMessage = await true;
      if (this.contactListParam.group_id.length == 0) {
        this.allContacts = "";
      }
      await this.$store
        .dispatch("contact/getContactList", this.contactListParam) // sesuai kan dengan method di API
        .then(response => {
          // console.log("response", response);
          // console.log("response.data.length", response.data.length);
          const { data } = response;
          // console.log("this.contactListParam.group_id.length",this.contactListParam.group_id.length,data)
          if (this.contactListParam.group_id.length == 0) {
            this.allContacts = response.totalRecords;
          }

          this.newData = data;
          //   console.log("thisssss", this.newData);
          if (this.newData.length > 0) {
            this.contactListArr.push(...this.newData);
            this.changeContactListArr(this.contactListArr);
            this.contactListParam.rendered =
              this.contactListParam.page + response.recordsFiltered;
            this.contactListParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.contactListParam.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;
            // this.infiniteHandler(this.currentState, 0, 0);
            $state.loaded();
          } else {
            this.loadingMessage = false;
            $state.completed();
          }
        })
        .catch(error => {
          //   this.loading = false;
          this.loadingMessage = false;

          console.log("error", error);
        });
    }
  },
  async created() {
    // this.getContactList();
    this.changeContactListArr([]);
    this.getGroupList();
    this.$root.$on("getGroupList", dataParams => {
      console.log("dataparams", dataParams);
      this.getGroupList(dataParams);
    });
    // this.$root.$on("getGroupList", () => {
    //   let dataParams = { name: "", page: 0, perPage: 1000 };
    //   this.getGroupList(dataParams);
    // });
  },
  beforeDestroy() {
    // this.$root.$off("getGroupList");
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/list.vue